import React, { Component } from 'react';

class BoardsList extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = { data: [], loading: true };
    }

    componentDidMount() {
        fetch(`/failure/efect_boards`, {
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" },
        })
            .then(r => r.json())
            .then(j => this.setState({ data: j.data || [], loading: false }))
            .catch(() => this.setState({ data: [], loading: false }));
    }

    render() {
        const { data, loading } = this.state;

        return (
            <div className="rk-wrap">
                <div className="rk-table-card">
                    <div className="rk-table-scroll">
                        <table className="rk-table">
                            <thead>
                                <tr>
                                    <th>Causa</th>
                                    <th>Tablero</th>
                                    <th className="rk-table__num">Columnas</th>
                                    <th className="rk-table__num">Tareas</th>
                                    <th className="rk-table__actions"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr><td colSpan={5}><div className="rk-empty"><i className="fas fa-spinner fa-spin"></i><p>Cargando tableros…</p></div></td></tr>
                                )}
                                {!loading && data.length === 0 && (
                                    <tr><td colSpan={5}><div className="rk-empty"><i className="far fa-folder-open"></i><p>Aún no hay tableros de AMEF</p></div></td></tr>
                                )}
                                {!loading && data.map(b => (
                                    <tr key={b.cause_id}>
                                        <td className="rk-cell-primary">{b.cause_name || '—'}</td>
                                        <td className="rk-cell-muted">{b.board_name || '—'}</td>
                                        <td className="rk-table__num">{b.columns_count || 0}</td>
                                        <td className="rk-table__num">{b.tasks_count || 0}</td>
                                        <td className="rk-table__actions">
                                            <a href={`/failure/causes/${b.cause_id}`} data-turbolinks="true" className="rk-btn rk-btn--ghost" style={{ height: 32, padding: '0 12px' }}>
                                                <i className="fas fa-columns"></i> Abrir
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default BoardsList;
